export const navItems = [
  {
    name: 'Dashboard',
    url: '/dashboard',
    icon: 'icon-home',
    permission: 'dashboard'
  },
  {
    name: 'Team',
    url: '/users',
    icon: 'icon-note',
    permission: 'users'
  },
  // {
  //   name: 'Licenses',
  //   url: '/licenses',
  //   icon: 'icon-star',
  //   class: 'menu-icon-users',
  //   permission: 'licenses'
  // },
  {
    name: 'License Management',
    url: '/license-management',
    icon: 'icon-star',
    permission: 'license-management'
  },
  {
    name: 'Session Analysis',
    url: '/session-analysis',
    icon: 'icon-grid',
    permission: 'session-analysis'
  },
  {
    name: 'Assign to Coach Pool',
    url: '/assign-licenses',
    icon: 'icon-people',
    permission: 'assign-licenses'
  },
  {
    name: 'Inventory',
    url: '/inventory',
    icon: 'cil-storage',
    permission: 'inventory'
  },
  {
    name: 'Color Settings',
    url: '/settings',
    icon: 'icon-settings',
    permission: 'settings'
  },
  {
    name: 'Refund Requests',
    url: '/refund-requests',
    icon: 'icon-question',
    permission: 'refund-requests'
  },
  {
    name: 'Profile',
    url: '/profile',
    icon: 'icon-user',
    permission: 'profile'
  },
  {
    name: 'Subscription',
    url: '/subscription',
    icon: 'icon-credit-card',
    permission: 'subscription'
  },
  {
    name: 'Product Code',
    url: '/product-code-register',
    icon: 'icon-bag',
    permission: 'product-code-register'
  },
  {
    name: 'Discount Coupons',
    url: '/discount-coupons',
    icon: 'icon-tag',
    permission: 'discount-coupons'
  },
];
